import { createFileRoute } from '@tanstack/react-router'
import node, {
  type graphBranchesPageQuery,
} from '#gen/relay/graphBranchesPageQuery.graphql'
import { lazyLoadedComponent } from '#lib/routing/lazy-loaded-component'

export const Route = createFileRoute(
  '/_dashboard/$account/graphql/$graph/branches/$branch/settings/graph/branches',
)({
  staticData: { title: '[graph] - Branches' },
  async loader({ context, params }) {
    return context.preload<graphBranchesPageQuery>(node, params)
  },
  component: lazyLoadedComponent(
    () => import('#app/pages/settings/graph-branches-page'),
    'GraphBranchesPage',
  ),
})
